import { render, staticRenderFns } from "./AppSnackbars.vue?vue&type=template&id=515278d5&scoped=true"
import script from "./AppSnackbars.vue?vue&type=script&lang=js"
export * from "./AppSnackbars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515278d5",
  null
  
)

export default component.exports